import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import Constants from "../common/Constants";
import { IIndexType } from "../model/IndexType";
import IndexTypeMapper from "../service/IndexTypeMapper";
import IndexTypeParamMapper from "../service/IndexTypeParamMapper";

export default class UpdateIndexTypeInteractor {
  private updateResource: UpdateResourceInteractor<IIndexType>;

  constructor({ updateResource }: any) {
    this.updateResource = updateResource;
  }

  async execute(model: IIndexType) {
    return this.updateResource.execute(
      Constants.endpointBasePath,
      IndexTypeMapper,
      IndexTypeParamMapper,
      model,
      model.id
    );
  }
}
